<template>
    <DModal
        :show="showModal"
        :title="__('customers.contracts.quickstart.modal.title')"
        :message="__('customers.contracts.quickstart.modal.message')"
        is-confirm
        is-error
        @update:show="$emit('update:showModal', $event)"
        @confirm="quickstartContractConfirm"
        @close="$emit('close-modal')"
    />
</template>

<script>
export default {
    name: 'QuickstartContractModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close-modal', 'update:showModal'],
    methods: {
        quickstartContractConfirm () {
            this.$inertia.post(this.$route('customers.customers.contracts.quickstart-contract', {
                customer: this.contract.customer_id,
                contract: this.contract.id
            }),
            {},
            {
                onSuccess: () => {
                    this.$emit('close-modal')
                }
            })
        }
    }
}
</script>
